import QRCode from 'qrcode';

const qrItems = document.querySelectorAll('.qr');

class GenerateQR {
    init() {
        if (qrItems) this.generateHTML();
    }

    generateHTML() {
        qrItems.forEach(item => {
            const href = item.getAttribute('url');
            
            item.innerHTML = `
            <canvas class="mx-auto"></canvas>
            <div>
                Scan the code on your device to view a mobile preview or click
                <a href="${href}" rel="noopener noreferrer">here</a>
                to view in your browser.
            </div>
            `
            item.removeAttribute('url');

            this.generateQR(item.querySelector('canvas'), href);
        })
    }
    
    generateQR(canvas, url) {
        const options = {
            errorCorrectionLevel: 'M',
            type: 'image/jpeg',
            quality: 1,
            margin: 0,
            width: 200,
        }
    
        QRCode.toCanvas(canvas, url, options, function (error) {
            if (error) console.error(error)
        })
    }
}

export default new GenerateQR();